import { isEqual } from 'lodash'
import { useSelector, shallowEqual } from 'react-redux'

import { PageId } from 'routing/pages'
import { CobaltPath } from 'routing/Path'
import {
    selectDomainValue as selectUiDomainValue,
    selectResourceOfPage,
    selectDashboardOfPage,
    selectFilters,
    selectVisibleCombinedFilters,
    selectResourceParamsOfPage,
    selectVisibleMetricsOfTable,
    selectVisibleColumnsOfTable,
} from 'selectors/ui'
import { PageFilters, RootReduxState, Field, FieldSerialized } from 'types'

export function useUiDomainValue<T>(path: CobaltPath): T {
    return useSelector<RootReduxState, T>(
        (state) => selectUiDomainValue(state, path),
        shallowEqual
    )
}

export function useResourceParamsOfPage<T>(page: PageId): T {
    return useSelector<RootReduxState, T>(
        (state) => selectResourceParamsOfPage(state, page),
        shallowEqual
    )
}

export function useResourceOfPage<T>(page: PageId): T | null {
    return useSelector<RootReduxState, T>(
        (state) => selectResourceOfPage(state, page),
        shallowEqual
    )
}

export function useDashboardOfPage<T>(page: PageId): T {
    return useSelector<RootReduxState, T>(
        (state) => selectDashboardOfPage(state, page),
        shallowEqual
    )
}

export function usePageFilters(page: PageId): PageFilters {
    return useSelector<RootReduxState, PageFilters>(
        (state) => selectFilters(state, [page]),
        shallowEqual
    )
}

export function useVisibleCombinedFilters(path: CobaltPath): PageFilters {
    return useSelector<RootReduxState, PageFilters>(
        (state) => selectVisibleCombinedFilters(state, path),
        isEqual
    )
}

export function useVisibleMetricsOfTable<T = unknown>(
    path: CobaltPath,
    columnsConfig: Field<T>[] | FieldSerialized[]
): Field<T>[] {
    return useSelector<RootReduxState, Field<T>[]>(
        (state) => selectVisibleMetricsOfTable(state, path, columnsConfig),
        shallowEqual
    )
}

export function useVisibleColumnsOfTable<T = unknown>(
    path: CobaltPath,
    columnsConfig: Field<T>[] | FieldSerialized[]
): Field<T>[] {
    return useSelector<RootReduxState, Field<T>[]>(
        (state) => selectVisibleColumnsOfTable(state, path, columnsConfig),
        shallowEqual
    )
}
